import axios from '@/utils/axios.js'

import {Message} from 'element-ui'

export function articleInfo(articleId){
    return new Promise((resolve, reject)=>{
        axios.get('/portal/vue/YfPortalServlet',{
            params:{
                action: 'Article',
                articleId: articleId,
            }
        }).then(data=>{
            const model = data.navigate[data.navigate.length-1].type_model||''
            if(model=='4'||model=='3'){
                window.location.href=data.dt[0].sub_title
            }
            if(data.code=="1"){
                if(!data.up.article_id)data.up=""; 
                if(!data.down.article_id)data.down=""; 
                resolve({art:data.dt[0],msg:data.msg,code:data.code,nav:data.navigate,nextArt:data.down||'',prevArt:data.up||''}) 
            }else{
                Message.error(data.msg)
            }
            
        })

    })
     
    
}